export default "assets/images/contact-marker-6de4b558.svg";